export default __webpack_public_path__ + "static/media/eleven.2584c930.jpeg";